import Modal from 'components/Layout/Modal'
import React from 'react'
import NewAbstractSubmissionFormPopup from 'components/V2ForNewAbstractFlow/NewAbstractSubmissionFormPopup'
import PaymentProofUploadPopup from './PaymentProofUploadPopup'
import AddMember from 'pages/Common/ProfileManagement/AddMember'
import { useNavigate, useParams } from 'react-router-dom'

const ParticipantsPopup = ({ participantsPopup, onHide, selectedOption, setSelectedOption, getParticipants, filterData, searchPayload }) => {
    const params = useParams();
    const { memberType, moduleType, eventId } = params;
    const navigate = useNavigate()
    const isView = participantsPopup?.mode === "view" || false
    const editData = participantsPopup?.data || {}
    const options = [
        editData?.first_name && {
            key: "member",
            label: isView ? "View Member Details" : "Edit Member Details",
        },
        editData?.abstract_details?.paper_title && {
            key: "abstract",
            label: isView ? "View Abstract Details" : "Edit Abstract Details",
        },
        editData?.payment_proof && {
            key: "payment",
            label: isView ? "View Payment Proof" : "Edit Payment Proof",
        },
        editData?.co_authors?.length > 0 && isView && {
            key: "co_authors",
            label: "View Author & Co-Authors",
        },
    ].filter(Boolean);

    const handleBack = () => setSelectedOption(null)
    return (
        <>
            <div>
                {/* Main Options Popup */}
                {!selectedOption && (
                    <Modal
                        titleBesideClose={isView ? 'View Participants' : 'Edit Participants'}
                        onHide={onHide}
                        isTitleBorder
                        isTitleVerticalCenter
                        size="md"
                    >
                        <div className="cp-20 d-flex gap-3 flex-column">
                            {options.map((opt) => (
                                <div
                                    key={opt.key}
                                    onClick={() => opt.key === "co_authors" ? navigate(`/${memberType}/${moduleType}/event-details/${eventId}/participants/author-details/${editData?.request_id}`) : setSelectedOption(opt.key)}
                                    className="cursor-pointer text-center cps-20 cpe-20 cpt-12 cpb-12 text-16-500 br-5 bg-F3F4F8 color-black-olive grey-border"
                                >
                                    {opt.label}
                                </div>
                            ))}
                        </div>
                    </Modal>
                )}


                {/* Member Add/Edit */}
                {selectedOption === "member" && (
                    <AddMember
                        onHide={handleBack}
                        handelSuccess={() => {
                            setSelectedOption(null)
                            getParticipants({ ...filterData, ...searchPayload })
                        }}
                        editData={{
                            firstName: editData?.first_name || "",
                            lastName: editData?.last_name || "",
                            memberType: editData?.member_type || "",
                            email: editData?.email_id || "",
                            country_code: editData?.phone_county_code || "IN",
                            phone: editData?.phone_number || "",
                            country: editData?.country_id || "",
                            id: editData?.user_id
                        }}
                        isView={isView}
                        type='participant_request'
                    />
                )}

                {/* Abstract Add/Edit */}
                {selectedOption === "abstract" && editData && (
                    <NewAbstractSubmissionFormPopup
                        eventId={eventId}
                        data={{
                            ...editData,
                            resource_participat_paper: '1',
                            participat_request_id: editData?.request_id,
                        }}
                        onHide={() => {
                            handleBack()

                        }}
                        handelSuccess={() => {
                            getParticipants({ ...filterData, ...searchPayload })
                        }}
                        isView={isView}
                    />
                )}

                {/* Payment Proof */}
                {selectedOption === "payment" && (
                    <PaymentProofUploadPopup
                        onHide={handleBack}
                        requestId={editData?.request_id}
                        handelSuccess={() => {
                            getParticipants({ ...filterData, ...searchPayload })
                        }}
                        editData={editData}
                        isView={isView}
                    />
                )}
            </div>
        </>
    )
}

export default ParticipantsPopup
